export default "__VITE_ASSET__DTkSwI60__"